import React, { useEffect, useState } from "react";
import styles from "./index.module.css";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CoupeImg from "../../../assets/vehicle-types/coupe.png";
import { selectVehicleTypeList } from "../../../redux/features/vehicleType/vehicleTypeSlice";
import { getVehicleType } from "../../../redux/features/vehicleType/vehicleTypeService";

const VehicleTypes = () => {
  const dispatch = useDispatch();

  const [visibleCount, setVisibleCount] = useState(4);

  const { data: vehicleTypes } = useSelector(selectVehicleTypeList);

  useEffect(() => {
    if (vehicleTypes.length === 0) {
      dispatch(getVehicleType({ status: true }));
    }
  }, [vehicleTypes.length, dispatch]);

  const updateVisibleCount = () => {
    const width = window.innerWidth;

    if (width <= 430) setVisibleCount(1);
    else if (width <= 576) setVisibleCount(1);
    else if (width <= 774) setVisibleCount(2);
    else if (width <= 1024) setVisibleCount(3);
    else if (width <= 1200) setVisibleCount(4);
    else setVisibleCount(5);
  };

  useEffect(() => {
    updateVisibleCount();
    window.addEventListener("resize", updateVisibleCount);

    return () => window.removeEventListener("resize", updateVisibleCount);
  }, []);

  // Duplicate items for seamless loop
  const loopedItems = [...vehicleTypes, ...vehicleTypes];

  return (
    <div className={styles.mainDivWrapper}>
      <div className={`main-container`}>
        <div className={`container-content`}>
        {vehicleTypes.length !== 0 && (
          <div className={styles.mainDiv}>
            <div className={styles.vehicleWrapper}>
              <div className={styles.vehiclesWrapperDiv}>
                <div
                  className={styles.vehicles}
                  style={{
                    animationDuration: `${vehicleTypes.length * 5}s`,
                  }}
                >
                  {loopedItems.map((vehicleType, i) => (
                    <Link
                      to={`/vehicles?vehicleType=${vehicleType.name}`}
                      className={styles.vehicleTypeWrapper}
                      key={i}
                    >
                      <img
                        src={vehicleType?.image_url}
                        alt={vehicleType.name}
                        className={styles.typeImg}
                      />
                      <span className={styles.typeName}>
                        {vehicleType.name}
                      </span>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
    </div>
  );
};

export default VehicleTypes;